/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPriceList, ApiPriceListPosition } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PriceListPositionsController.
 */
export class PriceListPositionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /price_lists/{rootObjectId}/positions:query
     */
    public getListGet(pageSize: number, pageNo: number, rootObjectId: string): Promise<Result<ListInfo<ApiPriceListPosition>>> {
        const query = new URLSearchParams();
        query.set('pageSize', `${pageSize}`);
        query.set('pageNo', `${pageNo}`);

        return this.http.get<Result<ListInfo<ApiPriceListPosition>>>(`/price_lists/${rootObjectId}/positions:query`, query);
    }

    /**
     * Calls POST /price_lists/{rootObjectId}/positions:query
     */
    public getListPost(listRequest: ListRequest, rootObjectId: string): Promise<Result<ListInfo<ApiPriceListPosition>>> {
        return this.http.post<Result<ListInfo<ApiPriceListPosition>>, ListRequest>(`/price_lists/${rootObjectId}/positions:query`, listRequest);
    }

    /**
     * Calls POST /price_lists/{rootObjectId}/positions:prefill
     */
    public createPrefilled(rootObjectId: string): Promise<Result<ApiPriceListPosition>> {
        return this.http.post<Result<ApiPriceListPosition>, undefined>(`/price_lists/${rootObjectId}/positions:prefill`, undefined);
    }

    /**
     * Calls POST /price_lists/{rootObjectId}/positions:add-missing
     */
    public addAllServices(serviceIds: string[] | undefined, rootObjectId: string): Promise<Result<ApiPriceList>> {
        return this.http.post<Result<ApiPriceList>, string[] | undefined>(`/price_lists/${rootObjectId}/positions:add-missing`, serviceIds);
    }

    /**
     * Calls GET /price_lists/{rootObjectId}/positions/{childId}
     */
    public get(childId: string, rootObjectId: string): Promise<Result<ApiPriceListPosition>> {
        return this.http.get<Result<ApiPriceListPosition>>(`/price_lists/${rootObjectId}/positions/${childId}`);
    }

    /**
     * Calls POST /price_lists/{rootObjectId}/positions
     */
    public add(childDto: ApiPriceListPosition, rootObjectId: string): Promise<Result<ApiPriceListPosition>> {
        return this.http.post<Result<ApiPriceListPosition>, ApiPriceListPosition>(`/price_lists/${rootObjectId}/positions`, childDto);
    }

    /**
     * Calls PUT /price_lists/{rootObjectId}/positions/{childId}
     */
    public put(childId: string, childDto: ApiPriceListPosition, rootObjectId: string): Promise<Result<ApiPriceListPosition>> {
        return this.http.put<Result<ApiPriceListPosition>, ApiPriceListPosition>(`/price_lists/${rootObjectId}/positions/${childId}`, childDto);
    }

    /**
     * Calls DELETE /price_lists/{rootObjectId}/positions/{childId}
     */
    public removeChild(childId: string, rootObjectId: string): Promise<Result<ApiPriceListPosition>> {
        return this.http.delete<Result<ApiPriceListPosition>>(`/price_lists/${rootObjectId}/positions/${childId}`);
    }
}
